import { Footer, Header } from '@sketchnote/landing-page';
import { ContainerFixedMargin } from '@sketchnote/shared-components';
import Link from 'next/link';
import React from 'react';
import { useAuth } from 'src/shared/hooks/use-auth';

export const PageNotFound = (): JSX.Element => {
  const authData = useAuth((s) => s.userDetails);

  return (
    <>
      <div>
        <Header />
        <ContainerFixedMargin className="desktop:pt-164 laptop:pt-107 tablet:pt-107 mobile:pt-107 desktop:pb-90 tablet:mb-64  mobile:mb-32">
          <div className=" flex flex-col align-middle mx-auto items-center">
            <img
              src="https://res.cloudinary.com/samvibes/image/upload/v1624976435/landing/About/pagenotfound.png"
              alt="page not found"
              className="mb-32 max-w-182 max-h-248"
            />
            <p className="font-bold desktop:text-2xl text-center tablet:max-w-530 mobile:max-w-none laptop:text-2xl mb-16 tablet:text-base mobile:text-sm text-primary-800">
              Oops! Either you’re trying to access an invalid link or an outdated URL.
              <span className="block">Why not head to the dashboard and try again?</span>
            </p>

            {/* <p className="text-lg text-gray-500 mb-16">Suggested Sketchnote links</p>
            <div className="flex flex-wrap mx-auto items-center justify-center">
           
              <Link
                href={`/w/${authData?.memberInformation?.organisation?.organisationId}/dashboard`}
              >
                <a className="mr-12 py-13 px-24 bg-primary-100 text-primary-500 mb-16">Dashboard</a>
              </Link>

              <Link href={'/product'}>
                <a className="mr-12 py-13 px-24 bg-primary-100 text-primary-500 mb-16">Product</a>
              </Link>
              <Link href={'/pricing'}>
                <a className="mr-12 py-13 px-24 bg-primary-100 text-primary-500 mb-16">Pricing</a>
              </Link>

              <Link href={'https://qmgig9mowiq.typeform.com/to/jAnhXJXZ'}>
                <a className="mr-12 py-13 px-24 bg-primary-100 text-primary-500 mb-16">Contact</a>
              </Link>
            </div> */}
          </div>
        </ContainerFixedMargin>
        <Footer />
      </div>
    </>
  );
};
